// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XTBU","question":"styles_question__26M1t","description":"styles_description__150Er"};